module.exports = __webpack_public_path__ + "static/img/line.4796754.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/line.png
// module id = pufY
// module chunks = 1